(function() {
    'use strict';

    angular
        .module('2017SiteDesign')
        .controller('FooterController', FooterController);

    function FooterController($rootScope, sharedProperties, $window, $timeout) {
        var vm = this;
        vm.inverted = sharedProperties.getInverted();
        vm.invertedFunc = function() {
            vm.inverted = !vm.inverted;
            $rootScope.$broadcast('inverted', vm.inverted);
            sharedProperties.setInverted(vm.inverted);
        };
        vm.date = new Date();
        $timeout(function() {
            vm.slider = $window.tns({
                autoplay: true,
                container: '#awardscaro',
                items: 1,
                gutter: 5,
                mouseDrag: true,
                swipeAngle: false,
                controlsText: ['<i aria-hidden="true" class="fas fa-arrow-circle-left"></i><span class="sr-only">Previous slide</span>', '<i aria-hidden="true" class="fas fa-arrow-circle-right"></i><span class="sr-only">Next slide</span>'],
                autoplayText: ['<i aria-hidden="true" class="fas fa-play"></i><span class="sr-only">Play Carousel</span>', '<i aria-hidden="true" class="fas fa-pause"></i><span class="sr-only">Pause Carousel</span>'],
                controls: false,
                responsive: {
                    768: {
                        items: 3
                    },
                    900: {
                        items: 5,
                        controls: true
                    }
                }
            });
        });
    }
})();